module.exports = __webpack_public_path__ + "static/media/search.1e483613.svg";